import {
  THOUSANDTH_PART,
  DIGITS_REGEXP,
  NAME_SHORT_MAP,
  NAME_LONG_MAP,
  MILEAGE_WARRANTY_TOOLTIP_MESSAGE
} from './constants'
import {
  BIG_O_MILEAGE_WARRANTY
} from 'constant'

export const isNumericWarranty = (value = '') =>
  !!value && !isNaN(value.toString().trim().replace(',', '.'))

export const getWarrantyValueForBadge = (warranty = '') =>
  (warranty.match(DIGITS_REGEXP) || []).join('') / THOUSANDTH_PART

export const isTreadLifeWarranty = (warranty = '') =>
  Boolean(warranty && isNumericWarranty(warranty))

export const isMileageWarranty = ({ name, value }) =>
  name === BIG_O_MILEAGE_WARRANTY && isNumericWarranty(value)

export const getDisplayName = ({ name, short = false }) =>
  short ? NAME_SHORT_MAP[name] || name
    : NAME_LONG_MAP[name] || name

export const getMileageWarrantyTooltipMsg = value =>
  MILEAGE_WARRANTY_TOOLTIP_MESSAGE.replace('#VALUE#', value.replace(',', '.'))
